var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLayers(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22.529,
    height: 21.236,
    viewBox: "0 0 22.529 21.236",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_878",
    "data-name": "Group 878",
    transform: "translate(-189.934 -1407.73)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1205",
    "data-name": "Path 1205",
    d: "M280.631,24.518l3.673-1.6,6.937-3.018c.655-.285.654-.285,1.307,0l9.275,4.03c.438.19.873.386,1.332.59,0,.537.005,1.077-.008,1.617,0,.059-.1.14-.165.17-.534.237-1.074.462-1.61.695q-4.575,1.989-9.146,3.986a.747.747,0,0,1-.667,0q-4.814-2.108-9.635-4.2-.56-.244-1.125-.477c-.108-.045-.174-.095-.172-.23.008-.515,0-1.03,0-1.564",
    transform: "translate(-90.693 1388.042)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1206",
    "data-name": "Path 1206",
    d: "M280.723,150.122l1.007.436,6.646,2.889c1.128.49,2.256.978,3.38,1.476a.5.5,0,0,0,.45,0q4.8-2.1,9.612-4.186c.46-.2.919-.4,1.406-.618v2.469c-.588.257-1.186.52-1.785.781q-3.543,1.544-7.086,3.085c-.739.321-1.483.632-2.223.953a.339.339,0,0,1-.3,0q-4.92-2.139-9.843-4.271c-.422-.183-.841-.371-1.264-.558Z",
    transform: "translate(-90.778 1271.526)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1207",
    "data-name": "Path 1207",
    d: "M303.277,103.695v2.452c-.438.194-.88.393-1.324.586q-1.7.744-3.411,1.484-3.154,1.367-6.309,2.735a.477.477,0,0,1-.423-.006q-2.893-1.27-5.793-2.527-2.485-1.079-4.972-2.15c-.089-.039-.177-.079-.272-.122V103.7c.36.155.7.3,1.036.445l6.5,2.822q1.425.62,2.849,1.243a.752.752,0,0,0,.171.073c.277.042.49.324.788.242a5.921,5.921,0,0,0,.764-.306q3.786-1.646,7.57-3.294l2.7-1.178c.031-.013.063-.024.131-.049",
    transform: "translate(-90.823 1312.996)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLayers);
export default __webpack_public_path__ + "static/media/layers.e9bacd2ff3c1d7f7fe331056297445e5.svg";
export { ForwardRef as ReactComponent };